import { render, staticRenderFns } from "./DiscountsWizard.vue?vue&type=template&id=16bb6be6&"
import script from "./DiscountsWizard.vue?vue&type=script&lang=js&"
export * from "./DiscountsWizard.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports